module.exports = __webpack_public_path__ + "static/media/pic04.f4090ab5.gif";